import { Injectable } from '@angular/core';

@Injectable()
export class CourseSearchFilterStateService {
	degreeLevels: 'open' | 'closed' = 'closed';
	locations: 'open' | 'closed' = 'closed';
	ucasPoints: 'open' | 'closed' = 'closed';
	studyOptions: 'open' | 'closed' = 'closed';
}
